import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {Button, Form, Header, Message,Icon} from 'semantic-ui-react';
import {DropzoneComponent} from 'react-dropzone-component';
import 'react-dropzone-component/styles/filepicker.css';
import 'dropzone/dist/min/dropzone.min.css';
import {INSPECTION_API_URL} from '../../constants/api_routes';
import InspectionContainer from "../../containers/inspection_container";
import FilterAttributes from "../../containers/filter_container";


class AdditionalDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            attachments: [],
            maxNumberOfFilesExceeded: false,
            success: undefined,
            message: undefined,
            notes:this.props.otherReport ? "Original Report (?)" : ""
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({uploading:true});
        const formData = new FormData(e.target);
        formData.append("notes", this.state.notes);
        for (let i = 0; i < this.state.attachments.length; i++) {
            formData.append("attachments[][file]", this.state.attachments[i]);
        }
        this.props.updateInspectionWithAdditionalNotes(INSPECTION_API_URL, formData, this.additionalDetailsAddedCallBack);
    };

    additionalDetailsAddedCallBack = (response) => {
        this.setState({uploading:false});
        if (response.success) {
            this.setState({success: true, message: "Successfully Added Notes for Inspection",disabled:true});
        }
    };
    removingFile = (file) => {
        let attachments = this.state.attachments;
        if (attachments.indexOf(file) !== -1) {
            attachments.splice(attachments.indexOf(file), 1);
        }
        return attachments;
    };

    render() {

        let dropZone = null;
        const componentConfig = {postUrl: 'no-url'};
        const djsConfig = {autoProcessQueue: false, addRemoveLinks: true, maxFiles: 3};
        const eventHandlers = {
            init: (dropzone) => {
                dropZone = dropzone
            },
            addedfile: (file) => {
                this.state.attachments.push(file)
            },
            removedfile: (file) => {
                this.setState({attachments: this.removingFile(file)})
            },
            maxfilesexceeded: (file) => {
                dropZone.removeFile(file);
                this.setState({maxNumberOfFilesExceeded: true});
                setTimeout(() => {
                    this.setState({maxNumberOfFilesExceeded: false})
                }, 10000)
            }
        };

        return (<div style={{margin: 'auto', width: '50%'}}>
            <Header content="Additional Details" textAlign="center"/>
            {this.state.success && <Message success onDismiss={() => {
                this.setState({success: undefined})
            }}><Message.Header> Successfully added Notes for Inspection </Message.Header>
                <Message.Content className="additional-pad"><Button content="View Created Inspection" primary onClick={() => {this.props.setFilter(undefined,undefined,undefined,this.props.newInspectionId);this.props.history.push('/inspection')}} /></Message.Content>
            </Message>}

            {this.state.uploading && <Message icon>
                <Icon name='circle notched' loading />
                <Message.Content>
                    <Message.Header>Please wait!</Message.Header>
                    Your Details are getting uploaded
                </Message.Content>
            </Message>}

            <Form onSubmit={this.handleSubmit} type="multipart/formdata">
                <input type="hidden" name='inspection_id' value={this.props.newInspectionId}/>
                <Form.TextArea onChange={(e)=>{this.setState({notes:e.target.value})}}value ={this.state.notes}label='Notes' placeholder='Inspection notes' />
                <Form.Field>
                    <label>Attachments</label>
                    {this.state.maxNumberOfFilesExceeded &&
                    <p><span className="error-message">Max number of allowed files is 3</span></p>}
                    <DropzoneComponent config={componentConfig}
                                       eventHandlers={eventHandlers}
                                       djsConfig={djsConfig}/>
                </Form.Field>
                <Form.TextArea label='Conclusion Notes' placeholder='Conclusion notes' name="comments"/>
                <div className="right-aligned"><Button primary content="Submit Details" disabled={this.state.disabled}/></div>
            </Form></div>);
    }

}

export default InspectionContainer(FilterAttributes(withRouter(AdditionalDetails)));


// WEBPACK FOOTER //
// ./src/views/inspection/inspection_additional_details.js